export default __webpack_public_path__ + "static/media/Nemesis.aebc3942.jpg";